import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  constructor(private api: ApiService) {}

  uploadFile(formData: FormData): Observable<any> {
    return this.api.POST<any>('files', formData);
  }
}
